// extracted by mini-css-extract-plugin
export default {"ecom-header":"woPn3Y","ecomHeader":"woPn3Y"};